/* SunCrew — Zoom con lupa + lightbox para la imagen de producto */
(function () {
  'use strict';
  var wrap = document.querySelector('.zoom-wrap');
  if (!wrap) return;

  var lens = wrap.querySelector('.zoom-lens');
  var lightbox = document.getElementById('zoom-lightbox');
  var ZOOM = 2.5;
  var LENS = 180;
  var src = wrap.getAttribute('data-zoom-src') || '';
  var visible = false;

  /* --- lupa al pasar el mouse (desktop) --- */
  wrap.addEventListener('mousemove', function (e) {
    var r = wrap.getBoundingClientRect();
    var x = e.clientX - r.left;
    var y = e.clientY - r.top;
    var lx = Math.min(Math.max(x, LENS / 2), r.width - LENS / 2);
    var ly = Math.min(Math.max(y, LENS / 2), r.height - LENS / 2);
    lens.style.left = (lx - LENS / 2) + 'px';
    lens.style.top = (ly - LENS / 2) + 'px';
    lens.style.backgroundImage = "url('" + src + "')";
    lens.style.backgroundSize = (r.width * ZOOM) + 'px ' + (r.height * ZOOM) + 'px';
    lens.style.backgroundPosition = ((x / r.width) * 100) + '% ' + ((y / r.height) * 100) + '%';
    if (!visible) {
      visible = true;
      wrap.classList.add('zooming');
    }
  });

  wrap.addEventListener('mouseleave', function () {
    visible = false;
    wrap.classList.remove('zooming');
  });

  /* --- clic: pantalla completa (desktop y movil) --- */
  wrap.addEventListener('click', function () {
    if (!lightbox) return;
    lightbox.querySelector('img').src = src;
    lightbox.classList.add('open');
    document.body.style.overflow = 'hidden';
  });

  function close() {
    if (!lightbox) return;
    lightbox.classList.remove('open');
    document.body.style.overflow = '';
  }

  var closeBtn = lightbox ? lightbox.querySelector('.zoom-lightbox-close') : null;
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();
